import * as Effect from "effect-app/Effect"
import * as S from "effect-app/Schema"
/**
 * As we want to use actual Date Objects in inputs,
 * and instead of leveraging the parser as a decoder from JSON, we wish to use it as a validator from Inputs.
 * This won't work with JSON because a Date is represented as an ISO string inside JSON, and when JSON is parsed, it remains a string.
 */
export const inputDate2 = S.inputDate
export type inputDate2 = Date | string
export type InputDate2 = Date

export class Timestamps extends S.Opaque<Timestamps, Timestamps.Encoded>()(
  S
    .Struct({
      createdAt: inputDate2,
      updatedAt: inputDate2
    })
    .annotate({ identifier: "Timestamps" })
) {}

export function makeTimestamps() {
  const createdAt = new Date()
  return Timestamps.make({
    createdAt,
    updatedAt: createdAt
  })
}

/**
 * JSON-shaped timestamps, for use from a store-boundary `jitM`: those run on
 * the raw JSON document, where a date is an ISO string and not a `Date`.
 * Use {@link makeTimestamps} on construction paths instead.
 */
export function makeTimestampsJson() {
  const createdAt = new Date().toISOString()
  return { createdAt, updatedAt: createdAt }
}

export const TimestampsProp = Timestamps.pipe(S.withConstructorDefault(Effect.sync(() => makeTimestamps())))

export const TimestampProps = {
  timestamps: TimestampsProp
}

export interface HasTimestamps {
  timestamps: Timestamps
}

// codegen:start {preset: model}
//
export namespace Timestamps {
  export interface Encoded extends S.StructNestedEncoded<typeof Timestamps> {}
}
//
// codegen:end
